export default (apiFetch) => async ({
  email,
  password,
  rememberMe,
  recaptchaResponse,
  nonce,
}) => {
  const response = await apiFetch({
    endpoint: "login",
    method: "POST",
    body: JSON.stringify({
      email,
      password,
      rememberMe,
      recaptchaResponse,
      nonce,
    }),
    nonce,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  return await response.json();
};
